<script setup lang="ts">
import type { DateRangePickerFieldValue } from '@/components/pickerFields/DateRangePickerField.vue';

import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import StateMultiSelectField from '@/components/fields/StateMultiSelectField.vue';
import DateRangePickerField from '@/components/pickerFields/DateRangePickerField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  dates?: DateRangePickerFieldValue | null;
  states?: string[] | null;
}

export interface ValidData {
  dates: DateRangePickerFieldValue;
  states: string[];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.weeklyReportSearchForm"
    data-testid="weeklyReportSearchForm"
    @submit.prevent="handleSubmit"
  >
    <DateRangePickerField
      v-model="formData.dates"
      size="lg"
      label="Date range"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <StateMultiSelectField
      v-model="formData.states"
      size="large"
      label="State"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="[$style.field, $style.multiSelectField]"
    />
    <KBtn
      type="submit"
      size="lg"
      prepend-icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    >
      Search
    </KBtn>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.weeklyReportSearchForm {
}
  .field {
    width: 17.5rem;
    display: inline-block;
    vertical-align: top;

    &.multiSelectField {
      width: 25rem;
    }
  }
  .field {
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
